// extracted by mini-css-extract-plugin
export default {"filterItemContainer":"SearchDropdown_filterItemContainer__9TD-p","filterType":"SearchDropdown_filterType__IICoY","closeIcon":"SearchDropdown_closeIcon__QPUeb"};